import React from 'react'
import s from './QuoteBar.module.css'
import { showHtml } from '@lib/utils/utils'

export interface QuoteBarProps {
  className?: string
  text?: string
  author?: string
  icon: string
}

const QuoteBar: React.FC<QuoteBarProps> = ((props) => {
  const {
    className,
    author,
    text,
    icon
  } = props

  return (
    <div className={s.root}>
      <p className="center">
        <span className={s.icon} dangerouslySetInnerHTML={showHtml(icon ?? '')}/>
      </p>
      <p className={`text-title-hp ${s.QuoteBarText}`}>
        {text}
      </p>
      <p className={`text-2xl md:text-3xl ${s.QuoteBarAuthor}`}>
        {author}
      </p>
      <p className="center">
        <span className={s.icon} dangerouslySetInnerHTML={showHtml(icon ?? '')}/>
      </p>
    </div>
  )
})

export default QuoteBar
